/* Common Imports */

import React from "react";
import { makeStyles } from "@material-ui/core/styles";

/* Component Imports */

import { Typography } from "@material-ui/core";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import NormalCard from "../../../cards/NormalCard";

const useStyles = makeStyles((theme) => ({
  sectionContainer: {
    display: "flex",
    flexDirection: "row",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      justifyContent: "center",
    },
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    margin: "1rem 0rem 2rem 0rem",
  },
  flex: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    width: "100%",
    gap: "1.875rem",
  },
  subHeading: {
    width: "100%",
    color: "#202020",
    fontWeight: "400",
    fontSize: "1.5rem",
    lineHeight: "1.75rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.125rem",
      lineHeight: "1.6875rem",
    },
  },
  accordionContainer: {
    width: "100%",
  },
  ghostCard: {
    visibility: "hidden",
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
    [theme.breakpoints.only("sm")]: {
      width: "30%",
    },
    [theme.breakpoints.only("md")]: {
      width: "30%",
    },
    [theme.breakpoints.only("lg")]: {
      width: "30%",
    },
    [theme.breakpoints.only("xl")]: {
      width: "30%",
    },
    /* XXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 640)]: {
      width: "30%",
    },
    /* XXXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 920)]: {
      width: "15%",
    },
  },
}));

const SectionFour = (props) => {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState("panel1");

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  return (
    <React.Fragment>
      <div className={classes.sectionContainer}>
        <Accordion
          square
          expanded={expanded === "panel1"}
          onChange={handleChange("panel1")}
          className={classes.accordionContainer}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls={props.ariacontrols}
            id={props.id}
          >
            <Typography
              variant="h5"
              component="h5"
              className={classes.subHeading}
            >
              Home Design
            </Typography>
          </AccordionSummary>
          <AccordionDetails className={classes.accordiondetail}>
            <div className={classes.flex}>
              <NormalCard
                icon="/images/icons/service/civil_interior_architecture.svg"
                title="Interior Design"
                text="Customize your home the way you always dreamt it to be"
              />
              <NormalCard
                icon="/images/icons/service/architecture.svg"
                title="Construction & Architecture"
                text="We help you in building your dream Home from scratch"
              />
              <span className={classes.ghostCard} />
            </div>
          </AccordionDetails>
        </Accordion>
      </div>
    </React.Fragment>
  );
};

export default SectionFour;
